import { render, staticRenderFns } from "./heatMap.vue?vue&type=template&id=23234c6c&"
import script from "./heatMap.vue?vue&type=script&lang=js&"
export * from "./heatMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports